module.exports = ".dropdown-buscar-ciudad {\n    position: absolute;\n    overflow-y: auto;\n    margin-top: 0px !important;\n    max-height: 300px;\n    width: 94%;\n    top: auto;\n    left: 14px;\n}\n\nli.active {\n    background-color: #2196F3;\n    border-color: #2196F3;\n}\n\nli.active>div.menu-info>div, li.active>div.menu-info>div {\n    color: #fff;\n}\n\n.bcItem:hover {\n    background-color: rgba(0, 84, 168, 0.15);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/control-app/shared/buscar-ciudad/buscar-ciudad.component.css
// module id = ./src/app/control-app/shared/buscar-ciudad/buscar-ciudad.component.css
// module chunks = main